<template>
  <div>
    <a-alert
      message="Code is not dupicate / Mã không được trùng"
      type="warning"
    />
    <br />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback label="Title / Tiêu đề" prop="title">
        <a-input v-model="form.title" placeholder="Enter text" />
      </a-form-model-item>
      <a-form-model-item has-feedback label="Code" prop="code">
        <a-input v-model="form.code" placeholder="Enter text" />
      </a-form-model-item>
    </a-form-model>

    <div
      style="text-align: right;"
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button @click="closeDrawerAdd" style="margin-right: 5px;" icon="close">
        Close
      </a-button>
      <a-button
        type="primary"
        @click="create()"
        :loading="iconLoading"
        icon="plus"
      >
        Create
      </a-button>
    </div>
  </div>
</template>
<script>
import queryItem from "../data/queryItem";
//components

export default {
  components: {},
  props: {
    closeDrawerAdd: {
      type: Function,
      default: null,
    },
    createdOnView: {
      type: Function,
    },
  },
  data() {
    return {
      iconLoading: false,
      form: {
        name: undefined,
        userIds: [],
      },
      rules: {
        title: [
          {
            required: true,
            message: "Required / Tên không được bỏ trống",
            trigger: "change",
          },
        ],
        code: [
          {
            required: true,
            message: "Required / Tên không được bỏ trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    create() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.iconLoading = true;
          console.log(this.form);
          this.$apollo
            .mutate({
              mutation: queryItem.queryCreate,
              variables: {
                ...this.form,
                mainShiftId: this.form.mainShiftId || null,
              },
            })
            .then(({ data }) => {
              if (data?.createParcelType) {
                this.$notification.success({
                  message: "Success",
                  description: "Updated Success!",
                });
                this.closeDrawerAdd();
                this.createdOnView(data.createParcelType);
              }
              this.iconLoading = false;
            })
            .catch((error) => {
              this.$notification.error({
                message: "Error",
                description: "Updated Error!",
              });
              this.iconLoading = false;
            });
        }
      });
    },
  },
};
</script>
<style></style>
